export default "__VITE_ASSET__C431f_wF__"